import { render, staticRenderFns } from "./low_and_no_stock.vue?vue&type=template&id=4b9c450d&"
import script from "./low_and_no_stock.vue?vue&type=script&lang=js&"
export * from "./low_and_no_stock.vue?vue&type=script&lang=js&"
import style0 from "./low_and_no_stock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports